export default {
  App: {
    DarkMode: 'app.darkMode',
    Locale: 'app.locale',
    TradeSlippage: 'app.tradeSlippage',
    TradeLiquidity: 'app.tradeLiquidity',
    TradeDeadline: 'app.tradeDeadline',
    EthereumTxType: 'app.ethereumTxType',
  },
  Trade: {
    Gasless: 'trade.gasless',
  },
  UserSettings: {
    Currency: 'userSettings.currency',
  },
  TokenLists: {
    Toggled: 'tokenLists.toggled',
  },
  Transactions: 'transactions',
};
